<template>
  <div class="page-header" :class="className">
    <b-container fluid="xl" class="header-content">
      <NavBarPC v-if="!isMobile" />
      <NavBarMobile v-else />
      <!--
      <div class="header-style-1">
        <b-row>
          <b-col cols="12" md="10">
            <slot name="title"></slot>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="6">
            <slot name="detail"></slot>
          </b-col>
        </b-row>

        <slot name="image"></slot>
      </div>
-->
    </b-container>
  </div>
</template>

<script>
import NavBarPC from './NavBar-pc'
import NavBarMobile from './NavBar-mobile'
import runtime from '../utils/runtime'

export default {
  name: 'HeaderStyles1',
  props: ['className'],
  components: {
    NavBarPC,
    NavBarMobile
  },
  data() {
    return {
      isMobile: runtime.isMobile()
    }
  }
}
</script>

<style lang="scss">
.lang-selector {
  .popover-body {
    padding: 10px 0 !important;
  }
}
</style>
<style scoped lang="scss">
.page-header {
  display: flex;
  flex-direction: column;
  height: fit-content;
  overflow-x: hidden;
  box-shadow: 0px 5px 10px -5px #9d9c9e;

  .header-content {
    position: relative;
    flex: 1;
    overflow: hidden;
    max-width: unset;
    text-align: center;
    padding: 0px;
  }
}

.header-style-1 {
  height: 100%;

  h1 {
    position: relative;
    z-index: 1;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 100px;
  }
  p {
    position: relative;
    z-index: 1;
    font-size: 16px;
    font-weight: 300;
    color: #ffffff;
    margin-top: 20px;
  }

  img {
    position: absolute;
    z-index: 0;
    right: 0;
    bottom: 0;
    max-width: 70%;
  }
}
</style>
<style scoped lang="scss">
@media (max-width: 768px) {
  .page-header {
    height: 3.5rem;
    padding-top: 1rem;
  }

  .header-style-1 {
    h1 {
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      margin-top: 30px;
    }
    p {
      font-size: 10px;
      margin-top: 10px;
      width: 100%;
      text-align: center;
    }
    img {
      max-width: 60%;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
